'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { prefixPath } from '@/hooks/useLocalePath';

/**
 * Drop-in replacement for next/link that automatically prepends the current
 * locale prefix to internal hrefs.
 *
 * - String href:  <LocaleLink href="/contact" />
 * - Object href:  <LocaleLink href={{ pathname: '/contact', query: { a: 1 } }} />
 * - External URL: left untouched
 * - Already-prefixed: left untouched
 */
export default function LocaleLink({ href, ...props }) {
  const pathname = usePathname();

  let resolvedHref;

  if (typeof href === 'object' && href !== null) {
    resolvedHref = { ...href, pathname: prefixPath(pathname, href.pathname) };
  } else {
    resolvedHref = prefixPath(pathname, href);
  }

  return <Link href={resolvedHref} {...props} />;
}
